(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  function initCartRecommendations(scope) {
    scope.querySelectorAll('[data-cart-recommendations]').forEach(function (section) {
      if (section.dataset.recommendationsBound) return;
      section.dataset.recommendationsBound = 'true';

      var grid = section.querySelector('[data-cart-recommendations-grid]');
      var productId = section.dataset.productId;
      if (!grid || !productId) return;

      var url =
        window.Shopify.routes.root +
        'recommendations/products?section_id=product-recommendations&product_id=' +
        productId +
        '&limit=4&intent=related';

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var content = doc.querySelector('#shopify-section-product-recommendations');

          if (content && content.querySelector('.product-card')) {
            grid.innerHTML = content.innerHTML;
            section.hidden = false;
          }
        })
        .catch(function (error) {
          console.error('Cart recommendations failed', error);
        });
    });
  }

  initCartRecommendations(document);

  document.addEventListener('shopify:section:load', function (event) {
    initCartRecommendations(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  function initCart(scope) {
    var root = scope.querySelector('[data-cart-root]');
    if (!root || root.dataset.cartBound) return;
    root.dataset.cartBound = 'true';

    var sectionId = root.dataset.sectionId;

    // Both the header cart link and the "Articles (N)" heading badge
    // share the data-cart-count hook, so one query reaches both.
    function adjustCartCount(delta) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(Math.max(0, (parseInt(el.textContent, 10) || 0) + delta));
      });
    }

    function setLoading(isLoading) {
      root.querySelectorAll('.cart-item__price, .cart__totals').forEach(function (el) {
        el.classList.toggle('is-loading', isLoading);
      });
    }

    function applyCartResponse(cartResponse) {
      // Reconciles with the server's actual count (the optimistic
      // adjustment above is a same-line delta; this corrects it if
      // anything server-side — a quantity rule, a free-gift threshold —
      // made the real change different).
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = String(cartResponse.item_count);
      });

      var sectionHtml = cartResponse.sections && cartResponse.sections[sectionId];
      if (!sectionHtml) return;

      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      if (fresh) root.innerHTML = fresh.innerHTML;
    }

    function changeItem(key, quantity) {
      setLoading(true);

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId })
      })
        .then(function (response) {
          return response.json();
        })
        .then(applyCartResponse)
        .catch(function (error) {
          console.error('Cart update failed', error);
          setLoading(false);
        });
    }

    // Parent + every child sharing its bundle id (if any) are dropped
    // from the DOM immediately — not waiting for confirmation from the
    // server — addressed by cart item key (stable) rather than line
    // index, which shifts as other lines are removed.
    function removeItemRow(itemRow) {
      var bundleId = itemRow.dataset.cartItemBundleId;
      var rows = bundleId
        ? Array.from(root.querySelectorAll('[data-cart-item][data-cart-item-bundle-id="' + bundleId + '"]'))
        : [itemRow];

      var removedQuantity = 0;
      var updates = {};

      rows.forEach(function (row) {
        var qtyEl = row.querySelector('[data-cart-quantity-value]');
        removedQuantity += qtyEl ? Number(qtyEl.textContent) : 1;
        updates[row.dataset.cartItemKey] = 0;

        // A configurator bundle's options have no row of their own (they're
        // listed under the vehicle), so their keys ride on its remove button.
        var removeButton = row.querySelector('[data-bundle-child-keys]');
        var childKeys = removeButton ? removeButton.dataset.bundleChildKeys.split(',').filter(Boolean) : [];
        childKeys.forEach(function (childKey) {
          updates[childKey] = 0;
          removedQuantity += 1;
        });

        row.remove();
      });

      adjustCartCount(-removedQuantity);
      setLoading(true);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sectionId })
      })
        .then(function (response) {
          return response.json();
        })
        .then(applyCartResponse)
        .catch(function (error) {
          console.error('Cart update failed', error);
          setLoading(false);
        });
    }

    var confirmModal = document.querySelector('[data-cart-confirm-modal]');
    var pendingRemoval = null;

    if (confirmModal && !confirmModal.dataset.confirmBound) {
      confirmModal.dataset.confirmBound = 'true';

      var cancelButton = confirmModal.querySelector('[data-cart-confirm-cancel]');
      var acceptButton = confirmModal.querySelector('[data-cart-confirm-accept]');

      if (cancelButton) {
        cancelButton.addEventListener('click', function () {
          pendingRemoval = null;
          confirmModal.close();
        });
      }

      if (acceptButton) {
        acceptButton.addEventListener('click', function () {
          var row = pendingRemoval;
          pendingRemoval = null;
          confirmModal.close();
          if (row) removeItemRow(row);
        });
      }

      // Same click-outside-to-close pattern used by the other dialogs in
      // this theme (side panels, hotspot panel).
      confirmModal.addEventListener('click', function (event) {
        if (event.target !== confirmModal) return;

        var rect = confirmModal.getBoundingClientRect();
        var inside =
          rect.top <= event.clientY &&
          event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX &&
          event.clientX <= rect.left + rect.width;

        if (!inside) {
          pendingRemoval = null;
          confirmModal.close();
        }
      });
    }

    root.addEventListener('click', function (event) {
      var decreaseButton = event.target.closest('[data-cart-quantity-decrease]');
      var increaseButton = event.target.closest('[data-cart-quantity-increase]');
      var removeButton = event.target.closest('[data-cart-remove]');

      if (decreaseButton || increaseButton) {
        var itemRow = (decreaseButton || increaseButton).closest('[data-cart-item]');
        var wrap = (decreaseButton || increaseButton).closest('[data-cart-quantity]');
        var key = itemRow.dataset.cartItemKey;
        var valueEl = wrap.querySelector('[data-cart-quantity-value]');
        var current = Number(valueEl.textContent);
        var next = increaseButton ? current + 1 : Math.max(0, current - 1);

        // Shown immediately rather than waiting for the round-trip;
        // prices (this line's and the totals) can't be predicted
        // client-side the same way, so those get a loading state
        // instead, cleared once the real numbers come back.
        valueEl.textContent = next;
        adjustCartCount(next - current);

        changeItem(key, next);
        return;
      }

      if (removeButton) {
        var targetRow = removeButton.closest('[data-cart-item]');

        if (confirmModal) {
          pendingRemoval = targetRow;
          confirmModal.showModal();
        } else {
          removeItemRow(targetRow);
        }
      }
    });
  }

  initCart(document);

  document.addEventListener('shopify:section:load', function (event) {
    initCart(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  function initSidePanels(scope) {
    scope.querySelectorAll('[data-side-panel-open]').forEach(function (button) {
      if (button.dataset.panelBound) return;
      button.dataset.panelBound = 'true';

      button.addEventListener('click', function () {
        var panel = document.getElementById(button.dataset.sidePanelOpen);
        if (panel) panel.showModal();
      });
    });

    scope.querySelectorAll('dialog.side-panel').forEach(function (panel) {
      if (panel.dataset.panelBound) return;
      panel.dataset.panelBound = 'true';

      panel.querySelectorAll('[data-side-panel-close]').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          panel.close();
        });
      });

      panel.addEventListener('click', function (event) {
        if (event.target !== panel) return;

        var rect = panel.getBoundingClientRect();
        var inside =
          rect.top <= event.clientY &&
          event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX &&
          event.clientX <= rect.left + rect.width;

        if (!inside) panel.close();
      });
    });
  }

  function initPredictiveSearch(scope) {
    var input = scope.querySelector('[data-predictive-search-input]');
    var results = scope.querySelector('[data-predictive-search-results]');
    if (!input || !results || results.dataset.searchBound) return;
    results.dataset.searchBound = 'true';

    var timer;

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);

      if (!term) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      timer = setTimeout(function () {
        fetch(
          window.Shopify.routes.root +
            'search/suggest?q=' +
            encodeURIComponent(term) +
            '&section_id=predictive-search&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide'
        )
          .then(function (response) {
            return response.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var section = doc.querySelector('#shopify-section-predictive-search');
            results.innerHTML = section ? section.innerHTML : '';
            results.hidden = false;
          })
          .catch(function (error) {
            console.error('Predictive search failed', error);
          });
      }, 300);
    });
  }

  initSidePanels(document);
  document.querySelectorAll('dialog.side-panel').forEach(function (panel) {
    initPredictiveSearch(panel);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initSidePanels(event.target);
    event.target.querySelectorAll('dialog.side-panel').forEach(function (panel) {
      initPredictiveSearch(panel);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The cart badge shares the data-cart-count hook other scripts (cart
  // page, quick add) write the new count into; hide it whenever that
  // count is 0.
  function initHeaderCartCount() {
    document.querySelectorAll('[data-header-cart-count]').forEach(function (badge) {
      if (badge.dataset.countBound) return;
      badge.dataset.countBound = 'true';
      new MutationObserver(function () {
        var count = parseInt(badge.textContent, 10) || 0;
        badge.hidden = !count;
        updateHeaderCta(count);
      }).observe(badge, { childList: true, characterData: true, subtree: true });
    });
  }

  // "Commander" (configured link) with an empty cart, "Panier (n)" (cart
  // page) otherwise — see the header__cta markup.
  function updateHeaderCta(count) {
    document.querySelectorAll('[data-header-cta]').forEach(function (cta) {
      var link = cta.querySelector('a');
      if (!link) return;
      var text = count > 0 ? cta.dataset.cartText + ' (' + count + ')' : cta.dataset.emptyText;
      var url = count > 0 ? cta.dataset.cartUrl : cta.dataset.emptyUrl;
      link.textContent = text;
      if (url) {
        link.setAttribute('href', url);
      } else {
        link.removeAttribute('href');
      }
    });
  }

  initHeaderCartCount();

  function initHeader() {
    var header = document.querySelector('.header');
    // The homepage hero, or any section flagged to sit under the header
    // the same way (landing page hero, see lp-hero.liquid).
    var hero = document.querySelector('.hero, [data-header-overlay]');

    if (header && hero && !header.dataset.overlayBound) {
      header.dataset.overlayBound = 'true';

      // Scrolled state from 100px down (the design's 50–150px window), or
      // once the announcement bar is out of view if it's taller.
      var announcementEl = document.querySelector('.header-announcement');
      var announcementHeight = announcementEl ? announcementEl.offsetHeight : 0;
      var scrollThreshold = Math.max(announcementHeight, 100);

      var headerIsFloating = null;
      var menu = header.querySelector('.header__menu');
      var floatingLogo = header.querySelector('.header__floating-logo');
      var floatingActions = header.querySelector('.header__floating-actions');

      // Desktop scrolled state (header.css): the black logo and CTA sit on
      // either side of the links and the grey rectangle wraps all three,
      // so CSS needs the links' width, the wider of the two sides (kept
      // symmetric so the links stay centered) and the CTA's height.
      // Those elements are always laid out on desktop (just invisible
      // until scrolled), so they can be measured up front.
      function syncFloatingSizes() {
        if (!menu || !floatingLogo || !floatingActions) return;
        if (!window.matchMedia('(min-width: 897px)').matches) return;

        var sideWidth = Math.max(floatingLogo.offsetWidth, floatingActions.offsetWidth);
        var pillHeight = Math.max(floatingActions.offsetHeight, menu.offsetHeight) + 16;
        header.style.setProperty('--header-menu-width', menu.offsetWidth + 'px');
        header.style.setProperty('--header-floating-side-width', sideWidth + 'px');
        header.style.setProperty('--header-pill-height', pillHeight + 'px');
      }

      function updateHeaderFloating() {
        var scrolled = window.scrollY > scrollThreshold;
        if (scrolled === headerIsFloating) return;
        headerIsFloating = scrolled;

        header.classList.toggle('header--overlay', !scrolled);
        header.classList.toggle('header--floating', scrolled);
      }

      syncFloatingSizes();
      window.addEventListener('resize', syncFloatingSizes);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncFloatingSizes);
      window.addEventListener('scroll', updateHeaderFloating, { passive: true });
      updateHeaderFloating();
    }

    var openButton = document.querySelector('[data-mobile-menu-open]');
    var dialog = document.querySelector('dialog.mobile-menu');

    if (openButton && dialog && !openButton.dataset.menuBound) {
      openButton.dataset.menuBound = 'true';

      openButton.addEventListener('click', function () {
        dialog.showModal();
      });

      dialog.querySelectorAll('[data-mobile-menu-close]').forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
          dialog.close();
        });
      });
    }

    var menuToggles = document.querySelectorAll('[data-menu-toggle]');

    menuToggles.forEach(function (toggle) {
      if (toggle.dataset.toggleBound) return;
      toggle.dataset.toggleBound = 'true';

      toggle.addEventListener('click', function () {
        var item = toggle.closest('.header__menu-item');
        var wasOpen = item.classList.contains('header__menu-item--open');

        // Only one such dropdown can be open at a time: opening one
        // closes any other, and re-clicking the open one closes it.
        menuToggles.forEach(function (otherToggle) {
          otherToggle.closest('.header__menu-item').classList.remove('header__menu-item--open');
          otherToggle.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          item.classList.add('header__menu-item--open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  initHeader();

  document.addEventListener('shopify:section:load', initHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Reveals every [data-intro-from] element (see the head script in
  // theme.liquid and the hidden/offset starting styles in critical.css)
  // by removing the class that puts them in that starting state. A
  // double rAF — rather than running this immediately — makes sure the
  // browser has actually painted the hidden state at least once first;
  // without it, the class removal can land in the same frame as the
  // initial paint and the transition never gets a "from" state to
  // animate away from.
  (function () {
    var html = document.documentElement;
    var overlay = document.querySelector('[data-intro-video]');

    // Intro already played this session: drop the (hidden) video.
    if (!html.classList.contains('intro-pending')) {
      if (overlay) overlay.remove();
      return;
    }

    var INTRO_FADE_MS = 600;
    var started = false;

    function startEntrance() {
      if (started) return;
      started = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          html.classList.remove('intro-pending');
        });
      });
      // Last step (video teaser) ends at 1.55s + 0.7s — see critical.css.
      setTimeout(function () {
        html.classList.remove('intro-in-progress');
        // Lets what waits for the intro (the home popup) go next.
        document.dispatchEvent(new CustomEvent('kilow:intro-done'));
      }, 2400);
    }

    if (!overlay) {
      startEntrance();
      return;
    }

    var video = overlay.querySelector('video');

    // Fades the intro video out, then starts the entrance animations.
    function finishVideo() {
      if (overlay.classList.contains('is-fading')) return;
      overlay.classList.add('is-fading');
      setTimeout(function () {
        overlay.remove();
        startEntrance();
      }, INTRO_FADE_MS);
    }

    if (!video) {
      finishVideo();
      return;
    }

    video.loop = false;
    video.muted = true;
    video.preload = 'auto';
    video.addEventListener('ended', finishVideo);
    video.addEventListener('error', finishVideo);

    var playing = video.play();
    if (playing && playing.catch) playing.catch(finishVideo);

    // Safety net (stalled network, very long file): never block the page.
    setTimeout(finishVideo, 12000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'kilow-home-popup-seen';
    // Pause before it shows, once the intro is over (or on arrival).
    var OPEN_DELAY_MS = 2500;
    var FADE_MS = 400;

    // Fades out, then closes (the dialog would vanish at once otherwise).
    function closePopup(popup) {
      if (!popup.open || popup.classList.contains('is-closing')) return;
      popup.classList.add('is-closing');
      setTimeout(function () {
        popup.classList.remove('is-closing');
        popup.close();
      }, FADE_MS);
    }

    function popupIn(scope) {
      return scope.querySelector('[data-home-popup]');
    }

    function bind(popup) {
      if (!popup || popup.dataset.bound) return;
      popup.dataset.bound = 'true';

      popup.addEventListener('click', function (event) {
        if (event.target.closest('[data-home-popup-close]')) {
          closePopup(popup);
          return;
        }
        // Click on the backdrop (outside the box) closes it.
        if (event.target !== popup) return;
        var rect = popup.getBoundingClientRect();
        var inside =
          rect.top <= event.clientY && event.clientY <= rect.bottom && rect.left <= event.clientX && event.clientX <= rect.right;
        if (!inside) closePopup(popup);
      });

      // Escape: same fade instead of the instant close.
      popup.addEventListener('cancel', function (event) {
        event.preventDefault();
        closePopup(popup);
      });
    }

    var popup = popupIn(document);
    bind(popup);

    if (popup && !(window.Shopify && window.Shopify.designMode)) {
      var seen = false;
      try {
        seen = sessionStorage.getItem(STORAGE_KEY) === '1';
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (error) {}
      // After the homepage intro (video, then the entrance animations), not
      // over it. intro-in-progress is set in <head> and removed by the hero
      // once the entrance ends; the timeout only guards against a hero
      // that never signals.
      if (!seen) {
        if (document.documentElement.classList.contains('intro-in-progress')) {
          var opened = false;
          var openPopup = function () {
            if (opened) return;
            opened = true;
            setTimeout(function () {
              popup.showModal();
            }, OPEN_DELAY_MS);
          };
          document.addEventListener('kilow:intro-done', openPopup, { once: true });
          setTimeout(openPopup, 16000);
        } else {
          setTimeout(function () {
            popup.showModal();
          }, OPEN_DELAY_MS);
        }
      }
    }

    // Theme editor: open while the section is selected.
    document.addEventListener('shopify:section:load', function (event) {
      bind(popupIn(event.target));
    });
    document.addEventListener('shopify:section:select', function (event) {
      var selected = popupIn(event.target);
      if (selected && !selected.open) selected.showModal();
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      var selected = popupIn(event.target);
      if (selected && selected.open) selected.close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-showcase"] && !Shopify.designMode) return;
  try {
    
  function initImageShowcase(root) {
    if (root.dataset.showcaseBound) return;
    root.dataset.showcaseBound = 'true';

    var slides = Array.from(root.querySelectorAll('[data-showcase-slide]'));
    var thumbs = root.querySelector('[data-showcase-thumbs]');
    if (slides.length === 0) return;

    function show(index) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-current', i === index);
      });
      if (thumbs) {
        Array.from(thumbs.children).forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
      }
    }

    if (thumbs && slides.length > 1) {
      slides.forEach(function (slide, i) {
        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'image-showcase__thumb';
        thumb.setAttribute('aria-label', String(i + 1));
        var template = slide.querySelector('[data-showcase-thumb]');
        if (template) thumb.appendChild(template.content.cloneNode(true));
        thumb.addEventListener('click', function () {
          show(i);
        });
        thumbs.appendChild(thumb);
      });
      thumbs.hidden = false;
    }

    show(0);
  }

  document.querySelectorAll('[data-image-showcase]').forEach(initImageShowcase);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-image-showcase]').forEach(initImageShowcase);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var back = document.querySelector('[data-lp-back]');
    var hero = back && back.closest('.lp-hero');
    if (!back) return;

    document.body.appendChild(back);

    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        back.classList.toggle('lp-back--past-hero', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
    }
  })();

  // Back to the previous page; straight to the homepage (the link's own
  // href) when the landing was opened directly.
  document.addEventListener('click', function (event) {
    var back = event.target.closest('[data-lp-back]');
    if (!back || window.history.length <= 1) return;
    event.preventDefault();
    window.history.back();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.querySelector('[data-lp-modal]');
    if (!modal) return;

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-lp-modal-open]')) {
        event.preventDefault();
        modal.showModal();
        return;
      }
      if (event.target.closest('[data-lp-modal-close]')) {
        modal.close();
      }
    });

    // Click on the backdrop (outside the modal box) closes it.
    modal.addEventListener('click', function (event) {
      if (event.target !== modal) return;
      var rect = modal.getBoundingClientRect();
      var inside =
        rect.top <= event.clientY && event.clientY <= rect.bottom && rect.left <= event.clientX && event.clientX <= rect.right;
      if (!inside) modal.close();
    });

    // "Prénom, Nom" in one field → Shopify's first / last name.
    var form = modal.querySelector('[data-lp-modal-form]');
    var MENU_KEY = 'kilow-lp-menu-hidden';
    var HISTORY_KEY = 'kilow-lp-history-length';
    if (form) {
      form.addEventListener('submit', function () {
        // Remembered for the success page that follows the post: whether
        // the landing was opened with ?menu=0, and where history stood (the
        // post adds an entry, so "back" has to skip it too).
        try {
          sessionStorage.setItem(MENU_KEY, document.documentElement.classList.contains('menu-hidden') ? '1' : '0');
          sessionStorage.setItem(HISTORY_KEY, String(window.history.length));
        } catch (error) {}

        var fullName = form.querySelector('[data-lp-full-name]');
        if (!fullName) return;
        var parts = fullName.value.replace(',', ' ').trim().split(/\s+/);
        form.querySelector('[data-lp-first-name]').value = parts.shift() || '';
        form.querySelector('[data-lp-last-name]').value = parts.join(' ');

        // Department → one more customer tag, added to the section's tag
        // (contact[tags] is a single comma-separated field).
        var department = form.querySelector('[data-lp-department]');
        var tags = form.querySelector('[data-lp-tags]');
        if (department && tags && department.value) {
          tags.value = [tags.dataset.baseTags, 'departement-' + department.value.toLowerCase()].filter(Boolean).join(', ');
        }
      });
    }

    // "Revenir à l'accueil": the home page, or in ?menu=0 mode a step back
    // to the page before the landing (past the form post's own entry).
    modal.addEventListener('click', function (event) {
      if (!event.target.closest('[data-lp-modal-home]')) return;
      var menuHidden = document.documentElement.classList.contains('menu-hidden');
      var before = NaN;
      try {
        menuHidden = menuHidden || sessionStorage.getItem(MENU_KEY) === '1';
        before = parseInt(sessionStorage.getItem(HISTORY_KEY), 10);
      } catch (error) {}
      if (!menuHidden) return;
      var steps = before ? window.history.length - before + 1 : 2;
      if (window.history.length <= steps) return;
      event.preventDefault();
      window.history.go(-steps);
    });

    // Back from Shopify's form post: reopen on the success / error message.
    if (modal.querySelector('[data-lp-modal-autoopen]')) modal.showModal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-configurator"]) return;
  try {
    
  function initConfigurators(scope) {
    scope.querySelectorAll('[data-configurator-form]').forEach(function (form) {
      var root = form.closest('.configurator');
      if (!root || root.dataset.configuratorBound) return;
      root.dataset.configuratorBound = 'true';

      var dataScript = root.querySelector('[data-configurator-data]');
      if (!dataScript) {
        console.error('Configurator: could not find [data-configurator-data] script tag.');
        return;
      }

      var data;
      try {
        data = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error('Configurator: failed to parse variant data JSON.', error);
        return;
      }

      var variants = data.variants;

      var priceEl = root.querySelector('[data-configurator-price]');
      var basePriceEl = root.querySelector('[data-configurator-base-price]');
      var summaryOptionsEl = root.querySelector('[data-configurator-summary-options]');
      var freeLabel = (summaryOptionsEl && summaryOptionsEl.dataset.freeLabel) || '';
      var colorLabel = (summaryOptionsEl && summaryOptionsEl.dataset.colorLabel) || '';
      var variantInput = form.querySelector('[data-configurator-variant-input]');
      // Pro mode (?type=pro on the same product URL): entries flagged with
      // their metaobject's pro_only field (a whole option, a value, a wood
      // value or a color) are hidden by CSS until this runs. In pro mode
      // they're revealed; otherwise they're removed along with their layers
      // before anything below collects cards for pricing/state, and a
      // removed default selection hands over to the next value in its group.
      // Must run before selectValues/toggles are collected.
      function applyProMode() {
        // Pro mode is set aside for now: ?type=pro is ignored, so pro-only
        // entries are always removed. To bring it back, restore:
        // var isPro = new URLSearchParams(window.location.search).get('type') === 'pro';
        var isPro = false;
        var proOnly = Array.from(root.querySelectorAll('[data-configurator-pro-only]'));

        if (isPro) {
          proOnly.forEach(function (el) {
            el.removeAttribute('data-configurator-pro-only');
          });
          return;
        }

        proOnly.forEach(function (el) {
          var layerId = el.dataset.layerId;
          var group = el.dataset.group;
          var wasActive = el.classList.contains('is-active');

          if (layerId) {
            root.querySelectorAll(
              '[data-configurator-value-layer="' + layerId + '"], [data-configurator-roof-for="' + layerId + '"], [data-configurator-bed-for="' + layerId + '"]'
            ).forEach(function (layer) {
              layer.remove();
            });
          }
          el.remove();

          if (wasActive && group) {
            var next = root.querySelector('[data-configurator-select-value][data-group="' + group + '"]');
            if (next) next.classList.add('is-active');
          }
        });

        // A color category left without any swatch drops its title too.
        root.querySelectorAll('.configurator__swatches').forEach(function (grid) {
          if (grid.querySelector('[data-configurator-select-value]')) return;
          var title = grid.previousElementSibling;
          if (title && title.classList.contains('configurator__swatches-title')) title.remove();
          grid.remove();
        });
      }

      applyProMode();

      var nativeGroups = Array.from(root.querySelectorAll('[data-configurator-native-option]'));
      var selectValues = Array.from(root.querySelectorAll('[data-configurator-select-value]'));
      var toggles = Array.from(root.querySelectorAll('[data-configurator-toggle]'));

      // Layer images render inside each option/color/wood block natively
      // (see those files) rather than in the viewer markup itself —
      // metaobject settings don't resolve via section.blocks cross-block
      // access (see the viewer's own comment in this file), so each
      // block renders its own where its settings do resolve. Move them
      // all into the viewer before anything else touches them, so their
      // position: absolute (relative to the viewer) lines up correctly.
      var viewer = root.querySelector('[data-configurator-stage]');
      if (viewer) {
        root.querySelectorAll('[data-configurator-value-layer], [data-configurator-roof-for], [data-configurator-bed-for]').forEach(function (layerImg) {
          viewer.appendChild(layerImg);
        });
      }

      var selectedNativeValues = nativeGroups.map(function (group) {
        var active = group.querySelector('.is-active');
        return active ? active.dataset.configuratorNativeValue : null;
      });

      function findVariantByOptions(optionValues) {
        return variants.find(function (variant) {
          return optionValues.every(function (value, i) {
            return variant.options[i] === value;
          });
        });
      }

      function findVariant() {
        return findVariantByOptions(selectedNativeValues);
      }

      function formatMoney(amount) {
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
          style: 'currency',
          currency: currency
        }).format(amount / 100);
      }

      var FADE_MS = 300;

      // Static crossfade, in place: the new layer fades in while the old
      // one fades out. A layer re-selected mid-fade cancels its pending
      // hide, so fast clicking never leaves the active color hidden.
      // Color swaps (and the color's roof / bed) crossfade in place, like
      // every other layer: the new one fades in while the old one fades
      // out (FADE_MS). direction is accepted for the callers but unused.
      //
      // Each channel (the body color, and each overlay: roof, bed) tracks
      // its own in-flight swap, so rapid clicks cancel the pending timers
      // and hide any stray layer of that channel before starting the next
      // swap, without touching the others. An overlay appearing with
      // nothing to swap from (roof / bed just selected) fades in.
      var swappingLayers = {};

      function resetSwap(layer) {
        layer.style.transition = '';
        layer.style.opacity = '';
        layer.style.clipPath = '';
        layer.style.translate = '';
        layer.classList.remove('configurator__layer--fading');
      }

      function swapColorLayer(newLayer, oldLayer, direction, channel) {
        var key = channel || 'color';
        var layers = swappingLayers[key] || new Set();
        swappingLayers[key] = layers;

        layers.forEach(function (layer) {
          clearTimeout(layer._fadeTimer);
          resetSwap(layer);
          if (layer !== oldLayer && layer !== newLayer) layer.hidden = true;
        });
        layers.clear();

        if (!newLayer || newLayer === oldLayer) {
          if (newLayer) newLayer.hidden = false;
          return;
        }

        clearTimeout(newLayer._fadeTimer);

        if (!oldLayer) {
          if (channel) {
            fadeLayer(newLayer, true);
          } else {
            resetSwap(newLayer);
            newLayer.hidden = false;
          }
          return;
        }

        resetSwap(newLayer);
        clearTimeout(oldLayer._fadeTimer);
        resetSwap(oldLayer);

        newLayer.classList.add('configurator__layer--fading');
        oldLayer.classList.add('configurator__layer--fading');
        newLayer.style.opacity = '0';
        newLayer.hidden = false;

        void newLayer.offsetWidth;

        newLayer.style.opacity = '1';
        oldLayer.style.opacity = '0';

        layers.add(newLayer);
        layers.add(oldLayer);

        oldLayer._fadeTimer = setTimeout(function () {
          oldLayer.hidden = true;
          resetSwap(oldLayer);
          resetSwap(newLayer);
          layers.delete(oldLayer);
          layers.delete(newLayer);
        }, FADE_MS);
      }

      // Same in-place fade for every other layer (option values, woods,
      // toggles, roof) shown or hidden on its own rather than swapped, so
      // the whole viewer transitions consistently. Shares _fadeTimer with
      // swapColorLayer: a newer fade on the same layer cancels the pending
      // end of an older one.
      function fadeLayer(layer, show) {
        if (!layer) return;
        clearTimeout(layer._fadeTimer);

        if (show) {
          if (!layer.hidden && layer.style.opacity !== '0') return;
          layer.classList.add('configurator__layer--fading');
          layer.style.opacity = '0';
          layer.hidden = false;
          void layer.offsetWidth;
          layer.style.opacity = '1';
          layer._fadeTimer = setTimeout(function () {
            layer.style.opacity = '';
            layer.classList.remove('configurator__layer--fading');
          }, FADE_MS);
          return;
        }

        if (layer.hidden) return;
        layer.classList.add('configurator__layer--fading');
        layer.style.opacity = '0';
        layer._fadeTimer = setTimeout(function () {
          layer.hidden = true;
          layer.style.opacity = '';
          layer.classList.remove('configurator__layer--fading');
        }, FADE_MS);
      }

      // The viewer's slides, stacked in place and crossfaded (no sideways
      // slide): an "intro" slide (the product's own first photo) when the
      // product has one, then the "base" slide (the layered composite) —
      // showBase()/showIntro() switch between them as the shopper moves
      // between the variant part and the options (see the observer below)
      // or picks a layered value. Any value without a layer_image (Volant's,
      // today) adds/updates a "photo" slide with its linked variant's own
      // product photo and fades to it; deselecting it fades back to the
      // base slide, then removes it. Photo slides are keyed (photoKey): a
      // single-choice option has one slide whose image changes with the
      // choice, a multiple-choice option one slide per checked value, and
      // each option keeps its own. One thumbnail per slide below the
      // image, plus a horizontal swipe on touch screens. Returns null if
      // the media wrapper isn't present, so callers can no-op safely.
      function initConfiguratorCarousel() {
        var media = root.querySelector('[data-configurator-media]');
        var thumbs = root.querySelector('[data-configurator-thumbs]');
        if (!media) return null;

        var introSlide = media.querySelector('[data-configurator-slide="intro"]');
        var baseSlide = media.querySelector('[data-configurator-slide="base"]');

        function getSlides() {
          return Array.from(media.querySelectorAll('[data-configurator-slide]'));
        }

        var currentSlide = getSlides()[0] || null;

        function isShowing(slide) {
          return slide === currentSlide;
        }

        function setActiveThumb() {
          if (!thumbs) return;
          var index = getSlides().indexOf(currentSlide);
          Array.from(thumbs.children).forEach(function (thumb, i) {
            thumb.classList.toggle('is-active', i === index);
          });
        }

        function showSlide(slide) {
          if (!slide) return;
          currentSlide = slide;
          getSlides().forEach(function (other) {
            other.classList.toggle('is-current', other === slide);
          });
          setActiveThumb();
        }

        // The composite slide's thumbnail is a live mini copy of the viewer:
        // every visible layer, stacked with the same z-index, rebuilt
        // whenever a layer is shown, hidden or restyled (observer below).
        var viewerEl = baseSlide ? baseSlide.querySelector('[data-configurator-stage]') : null;

        function buildCompositeThumb(container) {
          container.innerHTML = '';
          if (!viewerEl) return;
          viewerEl.querySelectorAll('.configurator__layer').forEach(function (layer) {
            if (layer.hidden || layer.tagName !== 'IMG') return;
            var copy = document.createElement('img');
            copy.src = layer.currentSrc || layer.src;
            copy.alt = '';
            copy.style.zIndex = getComputedStyle(layer).zIndex;
            container.appendChild(copy);
          });
        }

        function updateCompositeThumb() {
          if (!thumbs) return;
          var stack = thumbs.querySelector('[data-configurator-thumb-stack]');
          if (stack) buildCompositeThumb(stack);
        }

        if (viewerEl && 'MutationObserver' in window) {
          var thumbPending = false;
          new MutationObserver(function () {
            if (thumbPending) return;
            thumbPending = true;
            requestAnimationFrame(function () {
              thumbPending = false;
              updateCompositeThumb();
            });
          }).observe(viewerEl, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'style', 'src'] });
        }

        function refreshThumbs() {
          if (!thumbs) return;
          var slides = getSlides();
          thumbs.innerHTML = '';
          thumbs.hidden = slides.length < 2;
          if (thumbs.hidden) return;

          slides.forEach(function (slide) {
            var thumb = document.createElement('button');
            thumb.type = 'button';
            thumb.className = 'configurator__thumb' + (isShowing(slide) ? ' is-active' : '');
            thumb.addEventListener('click', function () {
              showSlide(slide);
            });

            if (slide === baseSlide && viewerEl) {
              var stack = document.createElement('span');
              stack.className = 'configurator__thumb-stack';
              stack.setAttribute('data-configurator-thumb-stack', '');
              buildCompositeThumb(stack);
              thumb.appendChild(stack);
            } else if (slide.dataset.configuratorThumb) {
              var img = document.createElement('img');
              img.src = slide.dataset.configuratorThumb;
              img.alt = '';
              thumb.appendChild(img);
            }
            thumbs.appendChild(thumb);
          });
        }

        // The photo slide's full-size URL is a Shopify CDN image_url, which
        // takes its size as a query param — reused small for the thumbnail.
        function thumbUrl(imageUrl) {
          try {
            var url = new URL(imageUrl, window.location.href);
            url.searchParams.set('width', '200');
            return url.toString();
          } catch (error) {
            return imageUrl;
          }
        }

        function photoSlideFor(key) {
          return getSlides().find(function (slide) {
            return slide.dataset.configuratorSlide === 'photo' && slide.dataset.photoKey === key;
          });
        }

        // Swipe left/right on touch screens to step through the slides.
        var touchStartX = null;
        media.addEventListener('touchstart', function (event) {
          touchStartX = event.touches[0].clientX;
        }, { passive: true });
        media.addEventListener('touchend', function (event) {
          if (touchStartX === null) return;
          var deltaX = event.changedTouches[0].clientX - touchStartX;
          touchStartX = null;
          if (Math.abs(deltaX) < 40) return;

          var slides = getSlides();
          var index = slides.indexOf(currentSlide) + (deltaX < 0 ? 1 : -1);
          if (index >= 0 && index < slides.length) showSlide(slides[index]);
        });

        showSlide(currentSlide);
        refreshThumbs();

        return {
          showBase: function () {
            if (baseSlide && !isShowing(baseSlide)) showSlide(baseSlide);
          },
          showIntro: function () {
            if (introSlide && !isShowing(introSlide)) showSlide(introSlide);
          },
          showPhoto: function (key) {
            var photoSlide = photoSlideFor(key);
            if (photoSlide && !photoSlide.dataset.removing && !isShowing(photoSlide)) showSlide(photoSlide);
          },
          // `silent`: create the slide without showing it (a photo value
          // selected by default on load).
          addPhotoSlide: function (key, imageUrl, silent) {
            if (!imageUrl) return;
            var slide = photoSlideFor(key);

            if (slide) {
              // Reselected while still fading back from a removal: keep it.
              delete slide.dataset.removing;
              slide.querySelector('img').src = imageUrl;
            } else {
              slide = document.createElement('div');
              slide.className = 'configurator__slide configurator__slide--photo';
              slide.dataset.configuratorSlide = 'photo';
              slide.dataset.photoKey = key;

              var img = document.createElement('img');
              img.src = imageUrl;
              img.alt = '';
              img.className = 'configurator__slide-image';

              slide.appendChild(img);
              media.appendChild(slide);
            }

            slide.dataset.configuratorThumb = thumbUrl(imageUrl);
            refreshThumbs();
            if (silent) return;

            // Next frame, so a new slide is in the DOM (at opacity 0)
            // before it's faded in.
            requestAnimationFrame(function () {
              showSlide(slide);
            });
          },
          removePhotoSlide: function (key) {
            var slide = photoSlideFor(key);
            if (!slide || slide.dataset.removing) return;
            slide.dataset.removing = 'true';

            function remove() {
              // Already gone, or reselected meanwhile (see addPhotoSlide).
              if (!slide.isConnected || !slide.dataset.removing) return;
              slide.remove();
              refreshThumbs();
            }

            if (!isShowing(slide)) {
              remove();
              return;
            }

            showSlide(baseSlide);
            setTimeout(remove, FADE_MS);
          }
        };
      }

      var carousel = initConfiguratorCarousel();

      // Default photo picks: a photo-only value selected on load (e.g.
      // Volant with "Select the first value by default") gets its photo
      // slide ready, shown when its part is scrolled to or a thumbnail is
      // clicked — the opening image stays the product photo.
      if (carousel) {
        root.querySelectorAll('[data-linked-variant-image].is-active').forEach(function (card) {
          if (!layerOf(card)) carousel.addPhotoSlide(photoKey(card), card.dataset.linkedVariantImage, true);
        });
      }

      // Mobile step bar: while the add-to-cart button is still below the
      // bottom of the screen, a fixed bar in its place offers "Suivant"
      // (and "Précédent" once past the 1st block), scrolling block by block
      // to just under the pinned image. As soon as the real button reaches
      // the bar's spot, the bar hides and the button simply scrolls on with
      // the page (into the footer) — same size, same place, no jump.
      function initStepNav() {
        var nav = root.querySelector('[data-configurator-step-nav]');
        var submit = root.querySelector('[data-configurator-submit]');
        if (!nav || !submit) return;

        var prevButton = nav.querySelector('[data-configurator-step-prev]');
        var nextButton = nav.querySelector('[data-configurator-step-next]');
        var stepStage = root.querySelector('.configurator__stage');
        var mobileQuery = window.matchMedia('(max-width: 1024px)');
        var BOTTOM_GAP = 16;
        var TOP_GAP = 16;
        var ticking = false;

        function sections() {
          return Array.from(root.querySelectorAll('[data-configurator-form] .configurator__section')).filter(function (section) {
            return section.getClientRects().length > 0;
          });
        }

        function readingLine() {
          return (stepStage ? stepStage.getBoundingClientRect().bottom : 0) + TOP_GAP;
        }

        function scrollPageBy(delta) {
          window.scrollTo({ top: window.scrollY + delta, behavior: 'smooth' });
        }

        // Last block whose top is on or above the reading line.
        function currentIndex(list) {
          var line = readingLine() + 2;
          var index = -1;
          list.forEach(function (section, i) {
            if (section.getBoundingClientRect().top <= line) index = i;
          });
          return index;
        }

        function update() {
          var showBar = mobileQuery.matches && submit.getBoundingClientRect().bottom > window.innerHeight - BOTTOM_GAP + 1;
          nav.hidden = !showBar;
          if (showBar) prevButton.hidden = currentIndex(sections()) < 1;
        }

        nextButton.addEventListener('click', function () {
          var list = sections();
          var next = list[currentIndex(list) + 1];
          if (next) {
            scrollPageBy(next.getBoundingClientRect().top - readingLine());
          } else {
            // Past the last block: bring the add-to-cart button to the bar.
            scrollPageBy(submit.getBoundingClientRect().bottom - (window.innerHeight - BOTTOM_GAP));
          }
        });

        prevButton.addEventListener('click', function () {
          var list = sections();
          var previous = list[currentIndex(list) - 1];
          if (previous) scrollPageBy(previous.getBoundingClientRect().top - readingLine());
        });

        function onScroll() {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            update();
          });
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        update();
      }

      initStepNav();

      // Ties the viewer to where the shopper is on the page, in both scroll
      // directions: whichever panel part sits on a reading line (see lineY)
      // decides the image — the variant part (and the
      // intro above it) shows the product photo, an option with layers the
      // layered composite, a photo-only option (Volant) with a value picked
      // that value's photo. Other parts leave the image as is. A thumbnail
      // click still wins until the next part crosses the line.
      // Toit / Benne values: shown on the composite through the color's
      // roof / bed (updateColorOverlays), so they count as layered.
      function isOverlayCard(card) {
        return card.dataset.configuratorIsRoof !== undefined || card.dataset.configuratorIsBed !== undefined;
      }

      function viewForPart(part) {
        if (part.matches('.configurator__intro') || part.querySelector('[data-configurator-native-option]')) {
          return 'intro';
        }

        // Revêtement: when one of its options added a photo (the shared
        // slot), that photo is what this part shows — its wood layers stay
        // on the composite, reached from the thumbnails.
        if (part.matches('[data-configurator-covering]') && coveringPhotoCard(part)) return 'covering';

        var hasLayer = Array.from(part.querySelectorAll('[data-layer-id]')).some(function (card) {
          return isOverlayCard(card) || root.querySelector('[data-configurator-value-layer="' + card.dataset.layerId + '"]');
        });
        if (hasLayer) return 'base';

        if (part.querySelector('[data-linked-variant-image].is-active')) return 'photo';
        return null;
      }

      if (carousel) {
        var stage = root.querySelector('.configurator__stage');
        var parts = Array.from(root.querySelectorAll('.configurator__intro, .configurator__section'));
        var pinnedImageQuery = window.matchMedia('(max-width: 1024px)');
        var partOnLine = null;
        var scrollTicking = false;

        // Desktop: 35% down the screen. Mobile/tablet, where the image is
        // pinned at the top: a bit below that image instead, so the part
        // that counts is the one the shopper is actually reading.
        function lineY() {
          if (pinnedImageQuery.matches && stage) {
            return stage.getBoundingClientRect().bottom + window.innerHeight * 0.15;
          }
          return window.innerHeight * 0.35;
        }

        // `apply` false on load: remember where we are without switching
        // away from the opening photo.
        function syncViewToScroll(apply) {
          var y = lineY();
          var part = parts.find(function (candidate) {
            var rect = candidate.getBoundingClientRect();
            return rect.top <= y && rect.bottom > y;
          });
          if (!part || part === partOnLine) return;
          partOnLine = part;
          if (!apply) return;

          var view = viewForPart(part);
          if (view === 'intro') carousel.showIntro();
          if (view === 'base') carousel.showBase();
          if (view === 'photo') {
            var photoCard = part.querySelector('[data-linked-variant-image].is-active');
            if (photoCard) carousel.showPhoto(photoKey(photoCard));
          }
          if (view === 'covering') carousel.showPhoto(coveringPhotoKey(part));
        }

        window.addEventListener(
          'scroll',
          function () {
            if (scrollTicking) return;
            scrollTicking = true;
            requestAnimationFrame(function () {
              scrollTicking = false;
              syncViewToScroll(true);
            });
          },
          { passive: true }
        );

        syncViewToScroll(false);
      }

      // Color-dependent overlays: Toit (is_roof) and Benne (is_bed) work
      // the same way. Turning on a value flagged with one of them (any
      // value in any option group, wood options included) shows the
      // *currently selected color's* own photo of that part — a variant
      // metafield on the color's linked variant (roof_image / bed_image),
      // pre-rendered per color as data-configurator-roof-for /
      // data-configurator-bed-for in configurator-color-swatches.liquid —
      // and swaps it with the same crossfade when the color changes. This
      // is on top of whatever layer_image the flagged value has itself
      // (shown/hidden normally by the click handlers). Several values can
      // carry the same flag, so only "is any of them active" matters.
      // Called on init, on every color change and on every option click.
      var COLOR_OVERLAYS = [
        { flag: 'data-configurator-is-roof', layerFor: 'data-configurator-roof-for' },
        { flag: 'data-configurator-is-bed', layerFor: 'data-configurator-bed-for' }
      ];
      var currentOverlayLayers = {};

      function updateColorOverlays() {
        var activeColor = root.querySelector('[data-configurator-select-value][data-group="__color__"].is-active');
        var colorId = activeColor ? activeColor.dataset.layerId : null;

        COLOR_OVERLAYS.forEach(function (overlay) {
          var current = currentOverlayLayers[overlay.flag] || null;
          var isActive = !!root.querySelector('[' + overlay.flag + '].is-active');
          var next = isActive && colorId ? root.querySelector('[' + overlay.layerFor + '="' + colorId + '"]') : null;

          if (next) {
            // The selected Toit / Benne value's own `level` (option
            // metaobject) beats the color's roof_level / bed_level.
            var flagged = root.querySelector('[' + overlay.flag + '].is-active[data-configurator-level]');
            if (next.dataset.baseZIndex === undefined) next.dataset.baseZIndex = next.style.zIndex;
            next.style.zIndex = flagged ? flagged.dataset.configuratorLevel : next.dataset.baseZIndex;
            swapColorLayer(next, current, 1, overlay.flag);
          } else if (current) {
            swapColorLayer(null, current, 1, overlay.flag);
            fadeLayer(current, false);
          }

          currentOverlayLayers[overlay.flag] = next;
        });
      }

      // Base layers with a slot (configurator_base's `slot`, e.g. "roues")
      // are hidden while any selected option value's `replaces` names that
      // slot — a wheel option swaps out the stock wheels instead of being
      // stacked over them — and come back when it's deselected.
      function updateBaseSlots() {
        var replaced = {};
        root.querySelectorAll('[data-configurator-replaces].is-active').forEach(function (card) {
          replaced[card.dataset.configuratorReplaces] = true;
        });

        root.querySelectorAll('[data-configurator-base-slot]').forEach(function (layer) {
          var slot = layer.dataset.configuratorBaseSlot;
          if (!slot) return;
          fadeLayer(layer, !replaced[slot]);
        });
      }

      // Option rules, from each configurator_option_value's own fields:
      //   excludes — values hidden (and deselected if they were picked)
      //              while this one is selected; one-way.
      //   requires — values selected automatically and locked while
      //              this one is selected; released (and
      //              deselected) as soon as nothing requires them anymore.
      //              A required value inside a wood that isn't the chosen
      //              one is ignored — list both woods' versions and only the
      //              active wood's is applied, priced and added to the cart.
      // Options only (not colors). Re-run until stable, since a required
      // value can itself require or exclude others.
      var ruleCards = Array.from(root.querySelectorAll('[data-configurator-select-value], [data-configurator-toggle]')).filter(
        function (card) {
          return card.dataset.group !== '__color__';
        }
      );

      // The cards a `requires` rule of `source` applies to. The same value
      // can sit in several lists (e.g. both dependent lists of a dependent
      // block), so only the usable copies count, and a copy in the source's
      // own list wins over the others.
      function requiredTargets(source, id) {
        var targets = ruleCards.filter(function (card) {
          return card.dataset.layerId === id && !inInactiveWood(card);
        });
        var list = source.closest('[data-configurator-wood-cards]');
        var sameList = targets.filter(function (card) {
          return list && card.closest('[data-configurator-wood-cards]') === list;
        });
        return sameList.length ? sameList : targets;
      }

      function idList(card, attribute) {
        var value = card.dataset[attribute];
        return value ? value.split(',').filter(Boolean) : [];
      }

      // Also true for a dependent block's greyed-out preview list.
      function inInactiveWood(card) {
        var wood = card.closest('[data-configurator-wood-cards]');
        return !!(wood && (wood.hidden || wood.dataset.configuratorDisabled !== undefined));
      }

      // Which photo slide a photo-only value uses: its single-choice
      // group's (one image per option, replaced on change), or its own for
      // a multiple-choice value (one image per checked value).
      function photoKey(card) {
        // Revêtement: one photo slot for both woods and all their options
        // (only one of them can show at a time).
        var covering = card.closest('[data-configurator-covering]');
        if (covering) return coveringPhotoKey(covering);
        if (card.dataset.configuratorToggle !== undefined) return 'value:' + card.dataset.layerId;
        return 'group:' + card.dataset.group;
      }

      var coveringCount = 0;
      function coveringPhotoKey(covering) {
        if (!covering.dataset.photoSlot) covering.dataset.photoSlot = 'covering:' + coveringCount++;
        return covering.dataset.photoSlot;
      }

      // Points the Revêtement's single photo slot at the right picture: the
      // preferred card if it has one, else the last selected option that
      // still shows a photo (no layer), else no slide at all. `silent`:
      // update the slot without bringing it on screen.
      // The Revêtement's selected options that show a photo (no layer, in
      // the visible wood), in page order.
      function coveringPhotoCards(covering) {
        return Array.from(covering.querySelectorAll('[data-linked-variant-image].is-active')).filter(function (card) {
          return !layerOf(card) && !card.closest('[hidden]');
        });
      }

      function coveringPhotoCard(covering) {
        var cards = coveringPhotoCards(covering);
        return cards[cards.length - 1] || null;
      }

      function syncCoveringPhoto(covering, preferred, silent) {
        if (!carousel) return;
        var key = coveringPhotoKey(covering);
        var candidates = coveringPhotoCards(covering);
        var pick = preferred && candidates.indexOf(preferred) !== -1 ? preferred : candidates[candidates.length - 1];
        if (pick) {
          carousel.addPhotoSlide(key, pick.dataset.linkedVariantImage, silent);
        } else {
          carousel.removePhotoSlide(key);
        }
      }

      // A card stops showing its photo: in the Revêtement the shared slot
      // falls back to another selected option's photo instead of closing.
      function releasePhoto(card, silent) {
        if (!carousel) return;
        var covering = card.closest('[data-configurator-covering]');
        if (covering) {
          syncCoveringPhoto(covering, null, silent);
        } else {
          carousel.removePhotoSlide(photoKey(card));
        }
      }

      function layerOf(card) {
        return card.dataset.layerId ? root.querySelector('[data-configurator-value-layer="' + card.dataset.layerId + '"]') : null;
      }

      // Selects / deselects a card with the same visual side effects as a
      // click (layer fade, photo slide; siblings of a single-choice group).
      // keepSiblings: a value force-selected by a `requires` rule must not
      // deselect the rest of its single-choice group — the value requiring
      // it may sit in that same group, and deselecting it would release the
      // requirement right away (both ended up unselected).
      function setCardActive(card, active, keepSiblings) {
        if (card.classList.contains('is-active') === active) return;

        if (active && !keepSiblings && card.dataset.configuratorSelectValue !== undefined) {
          root.querySelectorAll('[data-configurator-select-value][data-group="' + card.dataset.group + '"].is-active').forEach(function (other) {
            if (other !== card) setCardActive(other, false);
          });
        }

        card.classList.toggle('is-active', active);

        // Only the rules (requires / excludes) toggle cards through here:
        // an option checked as a consequence gets its photo slide ready
        // (thumbnail) but doesn't take the screen — only a click shows a
        // photo.
        var layer = layerOf(card);
        if (layer) {
          fadeLayer(layer, active);
        } else if (card.dataset.linkedVariantImage && carousel) {
          if (active) {
            var covering = card.closest('[data-configurator-covering]');
            if (covering) {
              syncCoveringPhoto(covering, card, true);
            } else {
              carousel.addPhotoSlide(photoKey(card), card.dataset.linkedVariantImage, true);
            }
          } else {
            releasePhoto(card, true);
          }
        }
      }

      function setLock(card, locked) {
        card.classList.toggle('is-locked', locked);
        card.setAttribute('aria-disabled', locked ? 'true' : 'false');
      }

      function applyRules() {
        for (var pass = 0; pass < 5; pass++) {
          var changed = false;

          var excluded = {};
          ruleCards.forEach(function (card) {
            if (!card.classList.contains('is-active')) return;
            idList(card, 'configuratorExcludes').forEach(function (id) {
              excluded[id] = true;
            });
          });

          var requiredBy = new Set();
          ruleCards.forEach(function (card) {
            if (!card.classList.contains('is-active') || excluded[card.dataset.layerId]) return;
            idList(card, 'configuratorRequires').forEach(function (id) {
              if (excluded[id]) return;
              requiredTargets(card, id).forEach(function (target) {
                requiredBy.add(target);
              });
            });
          });

          ruleCards.forEach(function (card) {
            var id = card.dataset.layerId;
            var isExcluded = !!excluded[id];

            card.hidden = isExcluded;

            if (isExcluded) {
              if (card.classList.contains('is-active')) {
                setCardActive(card, false);
                changed = true;
              }
              delete card.dataset.forced;
              setLock(card, false);
              return;
            }

            if (requiredBy.has(card)) {
              if (!card.classList.contains('is-active')) {
                setCardActive(card, true, true);
                card.dataset.forced = 'true';
                changed = true;
              }
              setLock(card, true);
              return;
            }

            setLock(card, false);
            if (card.dataset.forced) {
              delete card.dataset.forced;
              if (card.classList.contains('is-active')) {
                setCardActive(card, false);
                changed = true;
              }
            }
          });

          if (!changed) break;
        }
      }

      // Dependent-options blocks (configurator-dependent.liquid): only the
      // chosen main option's dependent list shows and is usable; with no
      // main option chosen, the 1st one's list shows greyed out and
      // disabled (a preview). Lists that aren't usable have their picks
      // cleared so they stop being priced or added to the cart. Main
      // options and dependent lists match by order (1st main → 1st list).
      function updateDependentBlocks() {
        root.querySelectorAll('[data-configurator-dependent]').forEach(function (block) {
          var mainCards = Array.from(block.querySelectorAll('[data-configurator-dependent-main] .configurator__card'));
          var activeIndex = mainCards.findIndex(function (card) {
            return card.classList.contains('is-active') && !card.hidden;
          });
          var lists = Array.from(block.querySelectorAll('[data-configurator-covering-content] [data-configurator-wood-cards]'));
          var optionsPart = block.querySelector('[data-configurator-dependent-options]');

          // The list to show: the chosen main option's, or the 1st one's as
          // a disabled preview when none is chosen.
          var shownIndex = activeIndex > -1 ? activeIndex : 0;
          var preview = activeIndex === -1;

          lists.forEach(function (list, index) {
            var show = index === shownIndex && !!list.querySelector('.configurator__card');
            var usable = show && !preview;

            list.hidden = !show;
            list.classList.toggle('is-disabled', show && preview);
            if (show && preview) {
              list.dataset.configuratorDisabled = '';
            } else {
              delete list.dataset.configuratorDisabled;
            }

            list.querySelectorAll('.configurator__card').forEach(function (card) {
              card.disabled = !usable;
              if (!usable && card.classList.contains('is-active')) {
                setCardActive(card, false);
                delete card.dataset.forced;
              }
            });
          });

          if (optionsPart) {
            optionsPart.hidden = !(lists[shownIndex] && !lists[shownIndex].hidden);
          }
        });
      }

      // Everything that depends on the overall selection rather than on
      // one clicked value: option rules (excludes / requires), then
      // color-dependent overlays (Toit, Benne) and base slots. Called on
      // init and after every selection change.
      function updateDependentLayers() {
        updateDependentBlocks();
        applyRules();
        updateColorOverlays();
        updateBaseSlots();
      }

      function initSelectLayers() {
        var groups = {};
        selectValues.forEach(function (card) {
          var groupId = card.dataset.group;
          groups[groupId] = groups[groupId] || [];
          groups[groupId].push(card);
        });

        Object.keys(groups).forEach(function (groupId) {
          var activeCard = groups[groupId].find(function (card) {
            return card.classList.contains('is-active');
          });
          if (activeCard && activeCard.dataset.layerId) {
            var layer = root.querySelector('[data-configurator-value-layer="' + activeCard.dataset.layerId + '"]');
            if (layer) layer.hidden = false;
          }
        });

        // Revêtement: the chosen wood's own layer.
        root.querySelectorAll('[data-configurator-wood-button].is-active').forEach(function (button) {
          var woodLayer = root.querySelector('[data-configurator-value-layer="' + button.dataset.configuratorWoodButton + '"]');
          if (woodLayer) woodLayer.hidden = false;
        });
      }

      // Variant cards show their own price, not a difference: "À partir
      // de" the cheapest variant carrying that option value.
      function updateNativeCardPrices() {
        nativeGroups.forEach(function (group, index) {
          group.querySelectorAll('[data-configurator-native-value]').forEach(function (card) {
            var cardPriceEl = card.querySelector('[data-configurator-native-price]');
            if (!cardPriceEl) return;

            var value = card.dataset.configuratorNativeValue;
            var prices = variants
              .filter(function (variant) {
                return variant.options[index] === value;
              })
              .map(function (variant) {
                return parseFloat(variant.price);
              });

            if (!prices.length) {
              cardPriceEl.textContent = '';
              return;
            }

            var label = cardPriceEl.dataset.priceFromLabel || '__PRICE__';
            cardPriceEl.textContent = label.replace('__PRICE__', formatMoney(Math.min.apply(null, prices)));
          });
        });
      }

      function updateSummaryOptions() {
        if (!summaryOptionsEl) return;

        summaryOptionsEl.innerHTML = '';

        function addRow(label, price) {
          var row = document.createElement('div');
          row.className = 'configurator__summary-row';

          var labelEl = document.createElement('span');
          labelEl.textContent = label;

          var priceEl = document.createElement('span');
          priceEl.textContent = price > 0 ? '+' + formatMoney(price) : freeLabel;

          row.appendChild(labelEl);
          row.appendChild(priceEl);
          summaryOptionsEl.appendChild(row);
        }

        selectValues.forEach(function (card) {
          if (card.classList.contains('is-active') && card.dataset.label) {
            var label =
              card.dataset.group === '__color__' && colorLabel
                ? colorLabel + ' : ' + card.dataset.label
                : card.dataset.label;
            addRow(label, parseFloat(card.dataset.price || 0));
          }
        });

        toggles.forEach(function (toggle) {
          if (toggle.classList.contains('is-active') && toggle.dataset.label) {
            addRow(toggle.dataset.label, parseFloat(toggle.dataset.price || 0));
          }
        });

        // Revêtement's chosen wood, when linked to a product.
        activeWoodButtons().forEach(function (button) {
          if (button.dataset.linkedVariantId) addRow(button.dataset.label, parseFloat(button.dataset.price || 0));
        });
      }

      // The chosen wood of each Revêtement block (configurator-covering):
      // priced and added to the cart when linked to a product.
      function activeWoodButtons() {
        return Array.from(root.querySelectorAll('[data-configurator-wood-button].is-active'));
      }

      function updatePrice() {
        var variant = findVariant();
        var total = variant ? parseFloat(variant.price) : 0;

        if (basePriceEl && variant) basePriceEl.textContent = formatMoney(parseFloat(variant.price));

        toggles.forEach(function (toggle) {
          if (toggle.classList.contains('is-active')) {
            total += parseFloat(toggle.dataset.price || 0);
          }
        });

        selectValues.forEach(function (card) {
          if (card.classList.contains('is-active')) {
            total += parseFloat(card.dataset.price || 0);
          }
        });

        activeWoodButtons().forEach(function (button) {
          total += parseFloat(button.dataset.price || 0);
        });

        updateSummaryOptions();

        if (priceEl) priceEl.textContent = formatMoney(total);
      }

      nativeGroups.forEach(function (group, index) {
        group.querySelectorAll('[data-configurator-native-value]').forEach(function (button) {
          button.addEventListener('click', function () {
            group.querySelectorAll('[data-configurator-native-value]').forEach(function (b) {
              b.classList.remove('is-active');
            });
            button.classList.add('is-active');
            selectedNativeValues[index] = button.dataset.configuratorNativeValue;

            var variant = findVariant();
            if (variant && variantInput) variantInput.value = variant.id;

            if (carousel) carousel.showIntro();

            updateNativeCardPrices();
            updatePrice();
          });
        });
      });

      // Optional select groups (configurator-option's default_first
      // unchecked): clicking the active value again deselects it, undoing
      // whatever it showed (its layer, or its photo slide).
      function deselectOptionalCard(card) {
        card.classList.remove('is-active');

        var layer = card.dataset.layerId ? root.querySelector('[data-configurator-value-layer="' + card.dataset.layerId + '"]') : null;
        if (layer) {
          fadeLayer(layer, false);
        } else if (card.dataset.linkedVariantImage && carousel) {
          releasePhoto(card);
        }

        updateDependentLayers();
        updatePrice();
      }

      selectValues.forEach(function (card) {
        card.addEventListener('click', function () {
          // Required by another selected option: locked until released.
          if (card.classList.contains('is-locked')) return;

          if (card.dataset.configuratorOptional !== undefined && card.classList.contains('is-active')) {
            deselectOptionalCard(card);
            return;
          }

          var groupId = card.dataset.group;
          var isColorGroup = groupId === '__color__';

          var previousActiveCard = root.querySelector(
            '[data-configurator-select-value][data-group="' + groupId + '"].is-active'
          );
          var previousActiveLayer =
            previousActiveCard && previousActiveCard.dataset.layerId
              ? root.querySelector('[data-configurator-value-layer="' + previousActiveCard.dataset.layerId + '"]')
              : null;
          // A value with neither a layer nor a linked-variant photo (rare —
          // e.g. a purely informational option) never used the carousel, so
          // this only matters when it's actually true.
          var previousUsedPhotoSlide = !!(
            previousActiveCard &&
            !previousActiveLayer &&
            previousActiveCard.dataset.linkedVariantImage
          );

          root.querySelectorAll('[data-configurator-select-value][data-group="' + groupId + '"]').forEach(function (other) {
            if (other === card) return;
            other.classList.remove('is-active');
            if (!isColorGroup && other.dataset.layerId) {
              var otherLayer = root.querySelector('[data-configurator-value-layer="' + other.dataset.layerId + '"]');
              fadeLayer(otherLayer, false);
            }
          });

          card.classList.add('is-active');

          // Toit (is_roof) can be one value among others in a select
          // group (e.g. one of Carrosserie's choices) rather than its own
          // block, and can coexist with its own layer_image — that layer
          // shows/hides normally below regardless of is_roof; the roof
          // itself is handled separately by updateColorOverlays.
          var layer = card.dataset.layerId ? root.querySelector('[data-configurator-value-layer="' + card.dataset.layerId + '"]') : null;

          if (layer || isOverlayCard(card)) {
            if (layer && isColorGroup) {
              swapColorLayer(layer, previousActiveLayer, 1);
            } else if (layer) {
              fadeLayer(layer, true);
            }
            if (previousUsedPhotoSlide && carousel) {
              releasePhoto(card);
            } else if (carousel) {
              carousel.showBase();
            }
          } else if (card.dataset.linkedVariantImage) {
            if (carousel) carousel.addPhotoSlide(photoKey(card), card.dataset.linkedVariantImage);
          } else if (previousUsedPhotoSlide && carousel) {
            releasePhoto(card);
          }

          // Covers both directions: selecting Toit itself, and switching
          // a select group away from Toit to a sibling value.
          updateDependentLayers();

          updatePrice();
        });
      });

      toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          if (toggle.classList.contains('is-locked')) return;

          var isActive = toggle.classList.toggle('is-active');

          // Toit (is_roof) can coexist with its own layer_image — that
          // layer shows/hides normally below regardless of is_roof; the
          // roof itself is handled separately by updateColorOverlays.
          var layer = toggle.dataset.layerId ? root.querySelector('[data-configurator-value-layer="' + toggle.dataset.layerId + '"]') : null;

          if (layer || isOverlayCard(toggle)) {
            if (layer) fadeLayer(layer, isActive);
            if (carousel) carousel.showBase();
          } else if (toggle.dataset.linkedVariantImage) {
            if (carousel) {
              if (isActive) {
                carousel.addPhotoSlide(photoKey(toggle), toggle.dataset.linkedVariantImage);
              } else {
                releasePhoto(toggle);
              }
            }
          }

          updateDependentLayers();

          updatePrice();
        });
      });

      // Revêtement's wood toggle: switching wood shows/hides each wood's
      // own card group and clears the hidden one's selection (so it stops
      // counting toward the price/summary), auto-activating the newly
      // shown wood's first value to match every other select group's
      // default-first behavior.
      root.querySelectorAll('[data-configurator-covering]').forEach(function (covering) {
        var woodButtons = Array.from(covering.querySelectorAll('[data-configurator-wood-button]'));

        woodButtons.forEach(function (button) {
          button.addEventListener('click', function () {
            var groupId = button.dataset.configuratorWoodButton;
            var otherGroupId = button.dataset.configuratorWoodOther;

            woodButtons.forEach(function (b) {
              b.classList.toggle('is-active', b === button);
              // The wood's own layer (block setting), if it has one.
              var woodLayer = root.querySelector('[data-configurator-value-layer="' + b.dataset.configuratorWoodButton + '"]');
              fadeLayer(woodLayer, b === button);
            });
            if (carousel && root.querySelector('[data-configurator-value-layer="' + groupId + '"]')) carousel.showBase();

            var cardsToShow = covering.querySelector('[data-configurator-wood-cards="' + groupId + '"]');
            var cardsToHide = covering.querySelector('[data-configurator-wood-cards="' + otherGroupId + '"]');

            if (cardsToHide) {
              cardsToHide.hidden = true;
              cardsToHide.querySelectorAll('.is-active').forEach(function (card) {
                card.classList.remove('is-active');
                if (card.dataset.layerId) {
                  var oldLayer = root.querySelector('[data-configurator-value-layer="' + card.dataset.layerId + '"]');
                  fadeLayer(oldLayer, false);
                }
              });
            }

            if (cardsToShow) {
              cardsToShow.hidden = false;

              // Only when the block asks for a default (options_default_first).
              if (covering.dataset.configuratorWoodDefaultFirst !== undefined && !cardsToShow.querySelector('.is-active')) {
                var firstCard = cardsToShow.querySelector('[data-configurator-select-value]');
                if (firstCard) {
                  firstCard.classList.add('is-active');
                  if (firstCard.dataset.layerId) {
                    var newLayer = root.querySelector('[data-configurator-value-layer="' + firstCard.dataset.layerId + '"]');
                    fadeLayer(newLayer, true);
                    if (newLayer && carousel) carousel.showBase();
                  }
                }
              }
            }

            // The hidden wood's options were just cleared (and the new
            // wood's first one maybe auto-picked): the shared photo slot
            // follows.
            syncCoveringPhoto(covering, cardsToShow && cardsToShow.querySelector('.is-active'));

            // A Toit/Benne value may just have been cleared or auto-picked.
            updateDependentLayers();

            updatePrice();
          });
        });

        // The chevron-toggled collapsible box around the wood options
        // themselves (see .configurator__covering-group) — purely
        // visual, doesn't touch selection state, so reopening it just
        // reveals whatever was already chosen. Animated via an explicit
        // max-height (not display/hidden) — scrollHeight stays accurate
        // even while currently clipped by max-height:0, same reasoning
        // as the product page's own accordion.
        var coveringToggle = covering.querySelector('[data-configurator-covering-toggle]');
        var coveringContent = covering.querySelector('[data-configurator-covering-content]');

        if (coveringToggle && coveringContent) {
          coveringToggle.addEventListener('click', function () {
            var isOpen = coveringToggle.classList.toggle('is-open');
            coveringToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

            if (isOpen) {
              coveringContent.style.maxHeight = coveringContent.scrollHeight + 'px';

              coveringContent.addEventListener(
                'transitionend',
                function handler(event) {
                  if (event.propertyName !== 'max-height') return;
                  coveringContent.removeEventListener('transitionend', handler);
                  // Only lift the cap if still open — a fast close click
                  // during the opening transition could otherwise leave
                  // it stuck at "none" instead of collapsing.
                  if (coveringToggle.classList.contains('is-open')) {
                    coveringContent.style.maxHeight = 'none';
                  }
                },
                { once: true }
              );
            } else {
              // Freeze at the current rendered height first (it may
              // currently be "none" from the transitionend above) —
              // a transition can't animate starting from "none".
              coveringContent.style.maxHeight = coveringContent.scrollHeight + 'px';
              void coveringContent.offsetHeight;
              coveringContent.style.maxHeight = '0px';
            }
          });
        }
      });

      // The cart lines for the current configuration (vehicle + one line per
      // priced option, grouped by _bundle_id), or null — with the error
      // shown — when no base variant is selected. Shared by add-to-cart and
      // quote mode.
      function buildItems() {
        var errorEl = root.querySelector('[data-configurator-error]');
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        var variantId = parseInt(variantInput.value, 10);
        if (!variantId) {
          console.error('Configurator: no base variant selected, cannot add to cart.');
          if (errorEl) {
            errorEl.textContent = errorEl.dataset.genericError;
            errorEl.hidden = false;
          }
          return null;
        }

        var bundleId =
          window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : Date.now() + '-' + Math.random().toString(36).slice(2);

        var parentItem = {
          id: variantId,
          quantity: 1,
          properties: { _bundle_id: bundleId, _bundle_role: 'parent' }
        };

        // The vehicle can carry kilow-app's deposit (a deferred purchase
        // option); when it's set to "only purchasable with a deposit",
        // Shopify rejects the line without its selling plan. The app keeps
        // a single deposit plan per product, hence the first allocation.
        var parentVariant = variants.find(function (variant) { return variant.id === variantId; });
        if (parentVariant && parentVariant.sellingPlanId) {
          parentItem.selling_plan = parentVariant.sellingPlanId;
        }

        var items = [parentItem];

        // Options sold with the vehicle carry kilow-app's "included in the
        // deposit" plan (nothing at checkout, paid with the balance), so the
        // whole configuration only costs the vehicle's deposit today. Only
        // when the vehicle itself is on its deposit plan.
        function childItem(el) {
          var item = {
            id: parseInt(el.dataset.linkedVariantId, 10),
            quantity: 1,
            properties: { _bundle_id: bundleId, _bundle_role: 'child' }
          };
          var planId = parseInt((el.dataset.sellingPlanId || '').trim(), 10);
          if (parentItem.selling_plan && planId) {
            item.selling_plan = planId;
          }
          return item;
        }

        toggles.forEach(function (toggle) {
          if (toggle.classList.contains('is-active') && toggle.dataset.linkedVariantId) {
            items.push(childItem(toggle));
          }
        });

        selectValues.forEach(function (card) {
          if (card.classList.contains('is-active') && card.dataset.linkedVariantId) {
            items.push(childItem(card));
          }
        });

        activeWoodButtons().forEach(function (button) {
          if (button.dataset.linkedVariantId) {
            items.push(childItem(button));
          }
        });

        return items;
      }

      function submitConfigurator() {
        var items = buildItems();
        if (!items) return;
        var errorEl = root.querySelector('[data-configurator-error]');

        var submitButton = root.querySelector('[data-configurator-submit]');
        if (submitButton) submitButton.disabled = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw err; });
            return response.json();
          })
          .then(function () {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch(function (error) {
            console.error('Configurator add to cart failed', error);
            if (errorEl) {
              errorEl.textContent = (error && error.description) || errorEl.dataset.genericError;
              errorEl.hidden = false;
            }
            if (submitButton) submitButton.disabled = false;
          });
      }

      // Quote mode (?quote=1, combinable with ?type=pro): the main button
      // (and the logged-out save modal's "order" button) opens the quote
      // modal instead of adding to the cart; its form posts the same items
      // plus the shopper's details to kilow-app, which creates the draft
      // order and emails its invoice.
      var isQuoteMode = new URLSearchParams(window.location.search).get('quote') === '1';
      var quoteModal = root.querySelector('[data-configurator-quote-modal]');

      if (isQuoteMode) {
        root.querySelectorAll('[data-quote-label]').forEach(function (button) {
          button.textContent = button.dataset.quoteLabel;
        });

        // The logo goes back to the previous page instead of the homepage.
        document.querySelectorAll('.header__logo, .header__floating-logo').forEach(function (logo) {
          logo.setAttribute('href', '#');
          logo.addEventListener('click', function (event) {
            event.preventDefault();
            history.back();
          });
        });
      }

      function checkout() {
        if (isQuoteMode && quoteModal) {
          if (buildItems()) quoteModal.showModal();
          return;
        }
        submitConfigurator();
      }

      if (quoteModal) {
        var quoteForm = quoteModal.querySelector('[data-configurator-quote-form]');
        var quoteError = quoteModal.querySelector('[data-configurator-quote-error]');
        var quoteSubmit = quoteModal.querySelector('[data-configurator-quote-submit]');
        var quoteSuccess = quoteModal.querySelector('[data-configurator-quote-success]');

        // Once the quote has been sent, closing the modal (its button, the
        // close cross, the backdrop or Esc) leads to the section's "after
        // quote" page, when one is set.
        quoteModal.addEventListener('close', function () {
          if (quoteModal.dataset.sent && quoteModal.dataset.redirectUrl) {
            window.location.href = quoteModal.dataset.redirectUrl;
          }
        });

        // Loading state while kilow-app creates the draft order and sends
        // its invoice (a few seconds): spinner + "Envoi en cours…", and no
        // second request until this one is over.
        var quoteSubmitLabel = quoteSubmit.textContent.trim();
        var quoteSending = false;

        function setQuoteSending(sending) {
          quoteSending = sending;
          quoteSubmit.disabled = sending;
          quoteSubmit.classList.toggle('is-loading', sending);
          quoteSubmit.setAttribute('aria-busy', sending ? 'true' : 'false');
          quoteSubmit.textContent = sending ? quoteSubmit.dataset.loadingLabel || quoteSubmitLabel : quoteSubmitLabel;
        }

        quoteForm.addEventListener('submit', function (event) {
          event.preventDefault();
          if (quoteSending) return;
          quoteError.hidden = true;

          if (!quoteForm.reportValidity()) return;

          var items = buildItems();
          if (!items) return;

          var fields = new FormData(quoteForm);
          setQuoteSending(true);

          // Not under Shopify.routes.root: app proxies live at the shop's
          // root path, outside any locale prefix.
          fetch('/apps/kilow/quote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: items,
              contact: {
                firstName: fields.get('firstName'),
                lastName: fields.get('lastName'),
                email: fields.get('email'),
                phone: fields.get('phone'),
                address1: fields.get('address1'),
                zip: fields.get('zip'),
                city: fields.get('city'),
                countryCode: fields.get('countryCode')
              },
              message: fields.get('message'),
              contestOptIn: fields.get('contestOptIn') === '1',
              website: fields.get('website')
            })
          })
            .then(function (response) {
              if (!response.ok) {
                return response.text().then(function (body) {
                  throw new Error('Configurator quote failed with status ' + response.status + ': ' + body);
                });
              }
              quoteForm.hidden = true;
              quoteSuccess.hidden = false;
              quoteModal.dataset.sent = 'true';
            })
            .catch(function (error) {
              console.error(error);
              quoteError.hidden = false;
            })
            .finally(function () {
              setQuoteSending(false);
            });
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        checkout();
      });

      // Saved configurations reference the same ids the page already uses
      // for its own state (native option values, metaobject value ids, wood
      // group ids), so restoring is just replaying clicks on whatever isn't
      // already in the saved state — every layer/price/roof/carousel side
      // effect then goes through the exact same handlers as a real click.
      function getConfig() {
        function activeIds(elements, attribute) {
          return elements
            .filter(function (el) { return el.classList.contains('is-active'); })
            .map(function (el) { return el.dataset[attribute]; });
        }

        return {
          native: selectedNativeValues.slice(),
          woods: activeIds(Array.from(root.querySelectorAll('[data-configurator-wood-button]')), 'configuratorWoodButton'),
          selects: activeIds(selectValues, 'layerId'),
          toggles: activeIds(toggles, 'configuratorToggle')
        };
      }

      function restoreConfig(config) {
        function clickIfInactive(el) {
          if (el && !el.classList.contains('is-active')) el.click();
        }

        nativeGroups.forEach(function (group, index) {
          var value = config.native && config.native[index];
          clickIfInactive(
            Array.from(group.querySelectorAll('[data-configurator-native-value]')).find(function (button) {
              return button.dataset.configuratorNativeValue === value;
            })
          );
        });

        // Woods first: a wood's cards are hidden (and unselectable) until
        // its own wood button is active.
        var woodButtons = Array.from(root.querySelectorAll('[data-configurator-wood-button]'));
        (config.woods || []).forEach(function (id) {
          clickIfInactive(woodButtons.find(function (button) { return button.dataset.configuratorWoodButton === id; }));
        });

        (config.selects || []).forEach(function (id) {
          clickIfInactive(selectValues.find(function (card) { return card.dataset.layerId === id; }));
        });

        toggles.forEach(function (toggle) {
          var shouldBeActive = (config.toggles || []).indexOf(toggle.dataset.configuratorToggle) !== -1;
          if (toggle.classList.contains('is-active') !== shouldBeActive) toggle.click();
        });
      }

      // "+" info triggers (section or option titles): open the shared info
      // modal with the trigger's own content. Listened in the capture phase
      // so a "+" inside an option card never also selects that option.
      var infoModal = root.querySelector('[data-configurator-info-modal]');
      var infoBody = infoModal && infoModal.querySelector('[data-configurator-info-body]');

      function openInfo(trigger) {
        // The info card holds its own template; a "+" has it right after.
        var content =
          trigger.querySelector(':scope > template[data-configurator-info-content]') || trigger.nextElementSibling;
        if (!infoModal || !content || !content.matches('[data-configurator-info-content]')) return;
        infoBody.innerHTML = '';
        infoBody.appendChild(content.content.cloneNode(true));
        infoModal.showModal();
      }

      root.addEventListener(
        'click',
        function (event) {
          var trigger = event.target.closest('[data-configurator-info-open]');
          if (!trigger) return;
          event.preventDefault();
          event.stopPropagation();
          openInfo(trigger);
        },
        true
      );

      root.addEventListener(
        'keydown',
        function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          var trigger = event.target.closest('[data-configurator-info-open]');
          if (!trigger) return;
          event.preventDefault();
          event.stopPropagation();
          openInfo(trigger);
        },
        true
      );

      // Shared by every dialog below (login modal, save confirmation,
      // restore prompt): any [data-configurator-dialog-close] button closes
      // its dialog, and so does a click on the backdrop. A click on the
      // dialog's own padding also targets the <dialog> element itself, hence
      // the bounding-box check (same as the cart's confirm modal).
      root.querySelectorAll('[data-configurator-dialog-close]').forEach(function (button) {
        button.addEventListener('click', function () {
          button.closest('dialog').close();
        });
      });

      root.querySelectorAll('dialog').forEach(function (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target !== dialog) return;

          var rect = dialog.getBoundingClientRect();
          var inside =
            rect.top <= event.clientY &&
            event.clientY <= rect.bottom &&
            rect.left <= event.clientX &&
            event.clientX <= rect.right;

          if (!inside) dialog.close();
        });
      });

      var saveButton = root.querySelector('button[data-configurator-save]');
      var saveStatus = root.querySelector('[data-configurator-save-status]');
      var savedDialog = root.querySelector('[data-configurator-saved]');

      if (saveButton) {
        saveButton.addEventListener('click', function () {
          saveButton.disabled = true;
          if (saveStatus) saveStatus.hidden = true;

          // Not under Shopify.routes.root: app proxies live at the shop's
          // root path, outside any locale prefix.
          fetch('/apps/kilow/configurator', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ productId: data.productId, config: getConfig() })
          })
            .then(function (response) {
              if (!response.ok) {
                return response.text().then(function (body) {
                  throw new Error('Configurator save failed with status ' + response.status + ': ' + body);
                });
              }
              if (savedDialog) savedDialog.showModal();
            })
            .catch(function (error) {
              console.error(error);
              if (saveStatus) {
                saveStatus.textContent = saveButton.dataset.errorLabel;
                saveStatus.hidden = false;
              }
            })
            .finally(function () {
              saveButton.disabled = false;
            });
        });
      }

      // Logged-out flow: the modal's login link carries the shopper away
      // from the page, so the configuration rides along in localStorage
      // until they come back logged in (?configurator_save=1), at which
      // point resumePendingSave replays it and saves it for them.
      var pendingSaveKey = 'kilow-configurator-pending-save-' + data.productId;
      var saveModal = root.querySelector('[data-configurator-save-modal]');

      if (saveModal) {
        root.querySelector('[data-configurator-save-modal-open]').addEventListener('click', function () {
          saveModal.showModal();
        });
        saveModal.querySelector('[data-configurator-save-modal-login]').addEventListener('click', function () {
          try {
            localStorage.setItem(pendingSaveKey, JSON.stringify(getConfig()));
          } catch (error) {
            console.error('Configurator: could not keep the configuration for after login.', error);
          }
        });
        saveModal.querySelector('[data-configurator-save-modal-order]').addEventListener('click', function () {
          saveModal.close();
          checkout();
        });
      }

      function resumePendingSave() {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('configurator_save')) return false;

        url.searchParams.delete('configurator_save');
        history.replaceState(history.state, '', url.toString());

        // Came back still logged out (login abandoned): keep the stashed
        // configuration for their next attempt.
        if (!saveButton) return false;

        var pending = null;
        try {
          pending = JSON.parse(localStorage.getItem(pendingSaveKey));
          localStorage.removeItem(pendingSaveKey);
        } catch (error) {
          console.error('Configurator: could not read the configuration kept for after login.', error);
        }
        if (!pending) return false;

        restoreConfig(pending);
        saveButton.click();
        saveButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }

      var restoreDialog = root.querySelector('[data-configurator-restore]');

      if (resumePendingSave()) {
        restoreDialog = null;
      }

      if (restoreDialog && data.saved) {
        restoreDialog.querySelector('[data-configurator-restore-load]').addEventListener('click', function () {
          restoreDialog.close();
          restoreConfig(data.saved);
        });
        restoreDialog.showModal();
      }

      initSelectLayers();
      updateNativeCardPrices();
      updateDependentLayers();
      updatePrice();
    });
  }

  initConfigurators(document);

  document.addEventListener('shopify:section:load', function (event) {
    initConfigurators(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  function initProductShowcaseGallery(gallery) {
    var views = Array.from(gallery.querySelectorAll('.product-view'));
    var thumbnailsContainer = gallery.querySelector('.product-showcase__thumbnails');
    var viewLabel = gallery.dataset.viewLabel || 'View';

    if (views.length === 0 || !thumbnailsContainer) return;

    thumbnailsContainer.innerHTML = '';
    // A single view has nothing to switch to.
    thumbnailsContainer.hidden = views.length < 2;

    views.forEach(function (view, i) {
      view.classList.toggle('is-active', i === 0);

      var thumbnailSource = view.querySelector('.product-view__thumbnail-source');
      var media = thumbnailSource ? thumbnailSource.firstElementChild : null;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'product-showcase__thumbnail' + (i === 0 ? ' is-active' : '');
      button.setAttribute('aria-label', viewLabel + ' ' + (i + 1));

      if (media) {
        button.appendChild(media.cloneNode(true));
      }

      button.addEventListener('click', function () {
        views.forEach(function (v, vi) {
          var isTarget = vi === i;
          v.classList.toggle('is-active', isTarget);
          v.classList.remove('is-entering');

          if (isTarget) {
            void v.offsetWidth;
            v.classList.add('is-entering');
            v.addEventListener(
              'animationend',
              function handler() {
                v.classList.remove('is-entering');
                v.removeEventListener('animationend', handler);
              },
              { once: true }
            );
          }
        });

        Array.from(thumbnailsContainer.children).forEach(function (t, ti) {
          t.classList.toggle('is-active', ti === i);
        });
      });

      thumbnailsContainer.appendChild(button);
    });
  }

  document.querySelectorAll('.product-showcase__gallery').forEach(initProductShowcaseGallery);

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.product-showcase__gallery').forEach(initProductShowcaseGallery);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function initProductGallery(scope) {
    scope.querySelectorAll('[data-product-media]').forEach(function (media) {
      if (media.dataset.galleryBound) return;
      media.dataset.galleryBound = 'true';

      var gallery = media.closest('.product__gallery');
      var progress = gallery && gallery.querySelector('[data-product-progress]');
      var slides = Array.from(media.children);

      function setActive(index) {
        if (!progress) return;
        progress.querySelectorAll('[data-product-progress-index]').forEach(function (segment, i) {
          segment.classList.toggle('is-active', i === index);
        });
      }

      if (progress) {
        progress.querySelectorAll('[data-product-progress-index]').forEach(function (segment) {
          segment.addEventListener('click', function () {
            var index = Number(segment.dataset.productProgressIndex);
            var target = slides[index];
            if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
        });
      }

      if (slides.length > 1 && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
            });
          },
          { root: media, threshold: 0.6 }
        );

        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }
    });
  }

  function updateReadMoreVisibility(description) {
    var button = description.parentElement.querySelector('[data-product-read-more]');
    if (!button || description.classList.contains('is-expanded')) return;
    // Only measurable once the panel is actually visible (display:none
    // elements report 0 for both), so this re-runs each time a panel opens
    // rather than once at page load.
    button.hidden = description.scrollHeight <= description.clientHeight + 1;
  }

  function initProductReadMore(scope) {
    scope.querySelectorAll('[data-product-description]').forEach(function (description) {
      if (description.dataset.readMoreBound) return;
      description.dataset.readMoreBound = 'true';

      var button = description.parentElement.querySelector('[data-product-read-more]');
      if (!button) return;

      description.classList.add('is-clamped');

      button.addEventListener('click', function () {
        // Read BEFORE toggling: this is the description's height as it
        // currently renders (and thus as already accounted for in the
        // panel's current max-height).
        var currentDescHeight = description.clientHeight;

        var expanded = description.classList.toggle('is-expanded');
        description.classList.toggle('is-clamped', !expanded);
        button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;

        var panelContent = description.closest('.product__panel-content');
        if (panelContent && panelContent.classList.contains('is-active')) {
          // The description and the panel each transition max-height
          // independently, so panelContent.scrollHeight measured right
          // now would only reflect however far the description's OWN
          // 0.3s transition has progressed in this same tick — i.e.
          // effectively not at all, since it just started. Compute the
          // description's actual target height instead of relying on a
          // live measurement of it mid-transition: scrollHeight is always
          // its true (unclamped) content height regardless of transition
          // state, and the clamped height is a known constant read back
          // from the CSS custom property rather than duplicated here.
          var targetDescHeight = expanded
            ? description.scrollHeight
            : parseFloat(getComputedStyle(description).getPropertyValue('--clamp-height'));
          panelContent.style.maxHeight =
            panelContent.scrollHeight - currentDescHeight + targetDescHeight + 'px';
        }
      });
    });
  }

  // Desktop: each item's trigger button and content div are physically
  // moved (once) into two independent containers — a flex tab row and a
  // plain block content area — instead of sharing one CSS Grid track-
  // sizing context (an earlier version kept both in the same grid via
  // `display: contents`, which let the content's paragraph text force
  // the whole accordion to grow to fit it unwrapped rather than letting
  // it wrap, making the component horizontally scrollable). Mobile: a
  // classic dropdown, so trigger/content stay paired in their natural
  // DOM position and nothing gets moved.
  function initProductAccordion(scope) {
    scope.querySelectorAll('.product__accordion').forEach(function (accordion) {
      if (accordion.dataset.accordionBound) return;
      accordion.dataset.accordionBound = 'true';

      var items = Array.from(accordion.querySelectorAll('[data-product-tab]'));
      if (items.length === 0) return;

      var isDesktop = window.matchMedia('(min-width: 897px)').matches;
      var pairs;

      if (isDesktop) {
        var tabs = document.createElement('div');
        tabs.className = 'product__accordion-tabs';

        var contentArea = document.createElement('div');
        contentArea.className = 'product__accordion-panels';

        pairs = items.map(function (item) {
          var trigger = item.querySelector('[data-product-tab-trigger]');
          var content = item.querySelector('[data-product-tab-content]');
          if (trigger) tabs.appendChild(trigger);
          if (content) contentArea.appendChild(content);
          return { trigger: trigger, content: content };
        });

        accordion.textContent = '';
        accordion.appendChild(tabs);
        accordion.appendChild(contentArea);
      } else {
        pairs = items.map(function (item) {
          return {
            trigger: item.querySelector('[data-product-tab-trigger]'),
            content: item.querySelector('[data-product-tab-content]')
          };
        });
      }

      // Desktop is a tab row, not an accordion — switching tabs should
      // swap content instantly, not fold/slide like the mobile dropdown.
      // Both share the same max-height mechanism (driven by the CSS
      // transition on .product__panel-content), so the only way to keep
      // one instant and the other animated is to disable the transition
      // for just this one assignment, then hand control back to the CSS
      // (empty string, not a hardcoded value, so it doesn't fight with
      // initProductReadMore's own max-height changes, which stay
      // animated on desktop).
      function setMaxHeight(content, value) {
        if (isDesktop) {
          content.style.transition = 'none';
          content.style.maxHeight = value;
          content.offsetHeight; // force reflow so the instant change commits
          content.style.transition = '';
        } else {
          content.style.maxHeight = value;
        }
      }

      function activate(target) {
        pairs.forEach(function (pair) {
          var isActive = pair === target;
          if (pair.trigger) pair.trigger.classList.toggle('is-active', isActive);
          if (pair.content) {
            pair.content.classList.toggle('is-active', isActive);
            // Explicit px height rather than a CSS-only trick, since
            // scrollHeight is accurate even while currently clipped by
            // max-height:0 — see the CSS comment on .product__panel-content.
            setMaxHeight(pair.content, isActive ? pair.content.scrollHeight + 'px' : '0px');
          }
          if (isActive && pair.content) {
            var description = pair.content.querySelector('[data-product-description]');
            if (description) {
              // Deferred a frame: checking scrollHeight/clientHeight in
              // the same tick as the class/style change above isn't
              // reliably settled yet (this is why the "Voir plus" button
              // only ever appeared starting on the second open). Also
              // re-syncs the panel's max-height afterward in case
              // revealing the button itself added height.
              requestAnimationFrame(function () {
                updateReadMoreVisibility(description);
                // Guard against the panel having been closed again (e.g.
                // a fast second click) before this frame ran.
                if (pair.content.classList.contains('is-active')) {
                  setMaxHeight(pair.content, pair.content.scrollHeight + 'px');
                }
              });
            }
          }
        });
      }

      pairs.forEach(function (pair) {
        if (pair.trigger) {
          pair.trigger.addEventListener('click', function () {
            // Mobile is a classic dropdown: clicking the open item closes
            // it. Desktop is a tab row: one is always active.
            if (!isDesktop && pair.trigger.classList.contains('is-active')) {
              activate(null);
            } else {
              activate(pair);
            }
          });
        }
      });

      if (isDesktop) activate(pairs[0]);
    });
  }

  function initProductOptions(scope) {
    scope.querySelectorAll('.product__form').forEach(function (form) {
      if (form.dataset.optionsBound) return;
      form.dataset.optionsBound = 'true';

      var container = form.closest('.product');
      var variantsScript = container && container.querySelector('[data-product-variants]');
      var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
      var variantIdInput = form.querySelector('[data-product-variant-id]');
      var priceEl = container && container.querySelector('[data-product-price]');
      var addButton = form.querySelector('[data-product-add-to-cart]');
      var errorEl = form.querySelector('[data-product-error]');
      // The variant picker is a sibling block, not a descendant of this
      // block's own <form>, so option groups are looked up from the
      // shared `.product` container instead of `form`.
      var optionGroups = container ? Array.from(container.querySelectorAll('[data-product-option-index]')) : [];

      function selectedOptions() {
        return optionGroups.map(function (group) {
          var active = group.querySelector('.product__option-value.is-active');
          return active ? active.dataset.productOptionValue : null;
        });
      }

      function findVariant() {
        var selected = selectedOptions();
        return variants.find(function (variant) {
          return selected.every(function (value, index) {
            return value === null || variant.options[index] === value;
          });
        });
      }

      // Slides the gallery to the variant's linked image, if it has one.
      // Scrolls the gallery itself rather than calling scrollIntoView, which
      // would also jump the page back up when the picker is below the fold.
      function showVariantImage(variant) {
        var media = container && container.querySelector('[data-product-media]');
        if (!media || !variant.image_id) return;

        var slide = media.querySelector('[data-image-id="' + variant.image_id + '"]');
        if (!slide) return;

        media.scrollBy({
          left: slide.getBoundingClientRect().left - media.getBoundingClientRect().left,
          behavior: 'smooth'
        });
      }

      function updateForVariant(variant) {
        if (!variant) return;
        showVariantImage(variant);
        variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
        }
      }

      optionGroups.forEach(function (group) {
        group.querySelectorAll('[data-product-option-value]').forEach(function (button) {
          button.addEventListener('click', function () {
            group.querySelectorAll('.is-active').forEach(function (active) {
              active.classList.remove('is-active');
            });
            button.classList.add('is-active');
            updateForVariant(findVariant());
          });
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (errorEl) errorEl.hidden = true;
        if (addButton) addButton.disabled = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantIdInput.value, 10), quantity: 1 }] })
        })
          .then(function (response) {
            if (!response.ok) return response.json().then(function (err) { throw err; });
            return response.json();
          })
          .then(function () {
            window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch(function (error) {
            console.error('Add to cart failed', error);
            if (errorEl) {
              errorEl.textContent = (error && error.description) || errorEl.dataset.genericError;
              errorEl.hidden = false;
            }
            if (addButton) addButton.disabled = false;
          });
      });
    });
  }

  function initProductRecommendations(scope) {
    scope.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      if (section.dataset.recommendationsBound) return;
      section.dataset.recommendationsBound = 'true';

      var grid = section.querySelector('[data-product-recommendations-grid]');
      var productId = section.dataset.productId;
      if (!grid || !productId) return;

      var url =
        window.Shopify.routes.root +
        'recommendations/products?section_id=product-recommendations&product_id=' +
        productId +
        '&limit=4&intent=related';

      fetch(url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var content = doc.querySelector('#shopify-section-product-recommendations');
          if (content) grid.innerHTML = content.innerHTML;
        })
        .catch(function (error) {
          console.error('Product recommendations failed', error);
        });
    });
  }

  function initProduct(scope) {
    initProductGallery(scope);
    initProductReadMore(scope);
    initProductAccordion(scope);
    initProductOptions(scope);
    initProductRecommendations(scope);
  }

  initProduct(document);

  document.addEventListener('shopify:section:load', function (event) {
    initProduct(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usage-highlights"] && !Shopify.designMode) return;
  try {
    
  class ScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.children);
      this.dots = [];
      this.duration = parseFloat(this.dataset.duration) || 5;
      this.hovered = false;
      this.visible = true;

      var dotsContainer = this.closest('.usage-highlights')?.querySelector('[data-usage-dots]');

      if (dotsContainer) {
        this.cards.forEach((card, index) => {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'usage-dots__dot';
          dot.setAttribute('aria-label', index + 1 + ' / ' + this.cards.length);

          var progress = document.createElement('span');
          progress.className = 'usage-dots__progress';
          dot.appendChild(progress);

          dot.addEventListener('click', () => {
            this.scrollToCard(card);
          });

          progress.addEventListener('animationend', () => {
            if (!dot.classList.contains('is-active')) return;
            var nextIndex = (index + 1) % this.cards.length;
            this.scrollToCard(this.cards[nextIndex]);
          });

          dotsContainer.appendChild(dot);
          this.dots.push(dot);
        });

        this.addEventListener('mouseenter', () => {
          this.hovered = true;
          this.updatePausedState();
        });
        this.addEventListener('mouseleave', () => {
          this.hovered = false;
          this.updatePausedState();
        });
      }

      var startIndex = (parseInt(this.dataset.startIndex, 10) || 1) - 1;
      startIndex = Math.min(Math.max(startIndex, 0), this.cards.length - 1);

      if (this.cards[startIndex]) {
        this.scrollToCard(this.cards[startIndex]);
      }

      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
        root: this,
        threshold: [0, 0.6, 1],
      });

      this.cards.forEach((card) => this.observer.observe(card));

      this.viewportObserver = new IntersectionObserver(
        (entries) => {
          this.visible = entries[0].isIntersecting;
          this.updatePausedState();
        },
        { threshold: 0 }
      );

      this.viewportObserver.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.viewportObserver?.disconnect();
    }

    scrollToCard(card) {
      var containerRect = this.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var cardCenterOffset = cardRect.left - containerRect.left + cardRect.width / 2;
      var delta = cardCenterOffset - containerRect.width / 2;

      this.scrollTo({ left: this.scrollLeft + delta, behavior: 'smooth' });
    }

    updatePausedState() {
      this.setPaused(this.hovered || !this.visible);
    }

    setPaused(paused) {
      this.dots.forEach((dot) => dot.classList.toggle('is-paused', paused));
    }

    activateDot(dot) {
      this.dots.forEach((d) => d.classList.remove('is-active'));
      dot.style.setProperty('--usage-dot-duration', this.duration + 's');
      void dot.offsetWidth;
      dot.classList.add('is-active');
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        var isActive = entry.intersectionRatio > 0.6;
        entry.target.classList.toggle('is-active', isActive);

        if (!this.dots.length) return;

        var index = this.cards.indexOf(entry.target);
        var dot = this.dots[index];
        if (!dot) return;

        if (isActive) {
          this.activateDot(dot);
        } else {
          dot.classList.remove('is-active');
        }
      });
    }
  }

  if (!customElements.get('scroll-carousel')) {
    customElements.define('scroll-carousel', ScrollCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
